import { render, staticRenderFns } from "./MediaGalleries.vue?vue&type=template&id=e668fbec&"
import script from "./MediaGalleries.vue?vue&type=script&lang=js&"
export * from "./MediaGalleries.vue?vue&type=script&lang=js&"
import style0 from "./MediaGalleries.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports